import { useMemo } from "react";
import {
  FormContainer,
  MandatoryNote,
} from "~/features/registration/components/CustomerRegistrationPage/components/common";
import { MenuItem, TextField } from "~/common/mui";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { MarketingConsent } from "~/features/marketingConsent/components/MarketingConsent";

interface Props {
  jobTitles: Record<string, string>;
}

export const Step2 = (props: Props) => {
  const { t } = useTranslation();

  const { jobTitleOptions } = useMemo(() => {
    return {
      jobTitleOptions: Object.entries(props.jobTitles).map(([code, labelKey]) => (
        <MenuItem key={code} value={code}>
          {t(labelKey)}
        </MenuItem>
      )),
    };
  }, [props, t]);

  return (
    <FormContainer>
      <Controller
        name={"fullName"}
        render={({ field, fieldState: { error } }) => (
          <TextField
            required
            variant={"outlined"}
            {...field}
            label={t(`page.selfRegistration.field.${field.name}.label`)}
            error={!!error}
            helperText={error ? t(error.message as string) : undefined}
          />
        )}
      />

      <Controller
        name={"jobTitle"}
        render={({ field, fieldState: { error } }) => (
          <TextField
            required
            select
            variant={"outlined"}
            {...field}
            label={t(`page.selfRegistration.field.${field.name}.label`)}
            placeholder={t(`page.selfRegistration.field.${field.name}.placeholder`)}
            error={!!error}
            helperText={error ? t(error.message as string) : undefined}
          >
            {jobTitleOptions}
          </TextField>
        )}
      />

      <Controller
        name={"email"}
        render={({ field, fieldState: { error } }) => (
          <TextField
            required
            variant={"outlined"}
            {...field}
            label={t(`page.selfRegistration.field.${field.name}.label`)}
            error={!!error}
            helperText={error ? t(error.message as string) : undefined}
          />
        )}
      />

      <Controller
        name={"telephone"}
        render={({ field, fieldState: { error } }) => (
          <TextField
            variant={"outlined"}
            {...field}
            label={t(`page.selfRegistration.field.${field.name}.label`)}
            error={!!error}
            helperText={error ? t(error.message as string) : undefined}
          />
        )}
      />
      <Controller
        name={"marketingConsent"}
        render={({ field: { value, onChange } }) => (
          <MarketingConsent.ConsentCheckbox hideTitle selected={value} setSelected={onChange} />
        )}
      />

      <MandatoryNote />
    </FormContainer>
  );
};
